var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDailyQuizActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33341 5.00033H1.66675V16.667C1.66675 17.5837 2.41675 18.3337 3.33341 18.3337H15.0001V16.667H3.33341V5.00033ZM16.6667 1.66699H6.66675C5.75008 1.66699 5.00008 2.41699 5.00008 3.33366V13.3337C5.00008 14.2503 5.75008 15.0003 6.66675 15.0003H16.6667C17.5834 15.0003 18.3334 14.2503 18.3334 13.3337V3.33366C18.3334 2.41699 17.5834 1.66699 16.6667 1.66699ZM16.6667 13.3337H6.66675V3.33366H16.6667V13.3337ZM11.2584 8.46699C11.6001 7.85866 12.2417 7.50033 12.6167 6.96699C13.0167 6.40033 12.7917 5.35033 11.6667 5.35033C10.9334 5.35033 10.5667 5.90866 10.4167 6.37533L9.27508 5.90033C9.59175 4.96699 10.4334 4.16699 11.6584 4.16699C12.6834 4.16699 13.3917 4.63366 13.7501 5.21699C14.0584 5.71699 14.2334 6.65866 13.7584 7.35866C13.2334 8.13366 12.7334 8.36699 12.4584 8.86699C12.3501 9.06699 12.3084 9.20033 12.3084 9.85032H11.0417C11.0501 9.50866 10.9917 8.95033 11.2584 8.46699ZM10.7917 11.6253C10.7917 11.1337 11.1834 10.7587 11.6667 10.7587C12.1584 10.7587 12.5334 11.1337 12.5334 11.6253C12.5334 12.1087 12.1667 12.5003 11.6667 12.5003C11.1834 12.5003 10.7917 12.1087 10.7917 11.6253Z",
    fill: "#F7631B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyQuizActive);
export default __webpack_public_path__ + "static/media/daily-quiz-active.936c1723bfbd32800e7597b9cb6d7bca.svg";
export { ForwardRef as ReactComponent };